import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useAuth } from '@/lib/auth';
import { Toaster } from '@/components/ui/sonner';
import { SimulationDisclaimer } from '@/components/common/SimulationDisclaimer';
import { api } from '@/lib/api';

export function AppShell() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const [org, setOrg] = useState(null);

  useEffect(() => {
    if (user?.org_id) {
      api.get(`/organizations/${user.org_id}`).then(r => setOrg(r.data)).catch(() => {});
    }
  }, [user?.org_id]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-background">
        <div className="text-sm text-muted-foreground">Loading Aakash Drishti…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;

  const showRibbon = !!org?.is_demonstration;

  return (
    <div className="app-shell-dark min-h-screen flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 relative z-10">
        {showRibbon && <SimulationDisclaimer variant="ribbon" />}
        <TopBar />
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
